/**
 * Ключи хранилища. Совпадают с теми, что пишет Android (`TimerStore`, `DayStore`, `NotesStore`),
 * потому что в Capacitor веб-слой работает с теми же `SharedPreferences`, а синхронизация
 * сравнивает разделы по одним и тем же именам. Менять их нельзя (§7.1 web-architecture.md).
 */
export const KEY = {
  childName: 'child_name',
  childBirth: 'child_birth',
  childGender: 'child_gender',
  gasVariant: 'gas_variant',
  /** Вес при рождении, граммы. Только веб: телефону и часам он не нужен. */
  childBirthWeight: 'child_birth_weight',
  /**
   * Анкету завели нажатием «Добавить второго малыша», а не первым запуском.
   * Такую запись сервер не сводит с похожей: человек сказал, что это другой ребёнок.
   */
  separateChild: 'separate_child',
  profileUpdatedAt: 'profile_updated_at',

  /** «Тур уже показывали» — про человека, поэтому ключ общий для всех малышей. */
  tourSeen: 'tour_seen',

  windowStart: 'window_start',
  windowUpdatedAt: 'window_updated_at',
  lastWake: 'last_wake',
  /** Ночное пробуждение идёт: момент нажатия «Проснулся» ночью. Не окно. */
  nightWakeStart: 'night_wake_start',
  /** Малыш спит с этого момента (ответ «да, уснул»): от него считаются напоминания о подъёме. */
  sleepingSince: 'sleeping_since',
  /** Режим дня: начало дня и укладывание в минутах от полуночи, напоминать ли о подъёме. */
  dayStartMin: 'day_start_min',
  bedtimeMin: 'bedtime_min',
  wakePush: 'wake_push',

  customPhases: (programId: string) => `custom_phases_${programId}`,
  phasesUpdatedAt: (programId: string) => `phases_updated_at_${programId}`,

  /** В вебе заметки и история режутся по месяцам: `notes_2026_09`, `windows_2026_09`. */
  notesMonth: (yearMonth: string) => `notes_${yearMonth}`,
  windowsMonth: (yearMonth: string) => `windows_${yearMonth}`,
} as const

export const NOTES_PREFIX = 'notes_'
export const WINDOWS_PREFIX = 'windows_'

/** `2026_09` для момента времени в местном поясе. */
export function yearMonthOf(millis: number): string {
  const date = new Date(millis)
  return `${date.getFullYear()}_${String(date.getMonth() + 1).padStart(2, '0')}`
}

/** `2026_09` для дня в виде epochDay (как хранится в заметке). */
export function yearMonthOfEpochDay(day: number): string {
  return yearMonthOf(day * 24 * 3600 * 1000)
}
